import { lazy } from "react";
import SEO from "@/components/SEO";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/home/HeroSection";
import DeferredSection from "@/components/DeferredSection";

// Below-the-fold sections load after the hero so the first paint stays fast.
const AboutSection = lazy(() => import("@/components/home/AboutSection"));
const AvailabilitySection = lazy(() => import("@/components/home/AvailabilitySection"));
const PricingSection = lazy(() => import("@/components/home/PricingSection"));
const CompanySection = lazy(() => import("@/components/home/CompanySection"));
const CTABanner = lazy(() => import("@/components/home/CTABanner"));
const IdealUseCasesSection = lazy(() => import("@/components/home/IdealUseCasesSection"));
const Footer = lazy(() => import("@/components/Footer"));

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Luxury Restroom Trailer Rentals for Events & Weddings"
        description="Luxury restroom trailer rentals for events, weddings, and job sites. Experience clean, upscale portable restrooms with reliable service."
      />
      <Navbar />
      <HeroSection />
      <DeferredSection minHeight={700}>
        <AboutSection />
      </DeferredSection>
      <DeferredSection minHeight={700}>
        <AvailabilitySection />
      </DeferredSection>
      <DeferredSection minHeight={900}>
        <PricingSection />
      </DeferredSection>
      <DeferredSection minHeight={700}>
        <CompanySection />
      </DeferredSection>
      <DeferredSection minHeight={320}>
        <CTABanner />
      </DeferredSection>
      <DeferredSection minHeight={700}>
        <IdealUseCasesSection />
      </DeferredSection>
      <DeferredSection minHeight={520}>
        <Footer />
      </DeferredSection>
    </div>
  );
};

export default Index;
